// extracted by mini-css-extract-plugin
export default {"shortener":"Shortener_shortener__G6Zqk","shortener__container":"Shortener_shortener__container__hcTA1"};